import * as React from 'react';
import { userSession } from 'state/session';
import { tenantConfig } from 'utils/tenant';

export interface ToggleProps {
  className?: string;
}

export const ExperienceToggle: React.FC<ToggleProps> = ({ className = '' }) => {
  const session = userSession().useState();
  const activeExperience = session.activeExperience || '2D';

  const handleToggle = () => {
    const newExperience = activeExperience === '3D' ? '2D' : '3D';
    userSession().setValues({ activeExperience: newExperience });
  };

  if (!tenantConfig().isAllowed('2D')) {
    return null;
  }

  const disabled = session.comparisonMode === 'on';

  return (
    <div className={`inline-flex items-center ${className}`}>
      {/* Toggle Switch */}
      <button
        onClick={handleToggle}
        className={`
          relative inline-flex h-8 w-16 items-center justify-between rounded-full px-2 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2
          ${activeExperience === '3D' ? 'bg-green-700' : 'bg-gray-300'}
        `}
        aria-pressed={activeExperience === '3D'}
        aria-label={`Switch to ${activeExperience === '3D' ? '2D' : '3D'} experience`}
        disabled={disabled}
      >
        {/* Left Label (2D) */}
        <span
          className={`pl-0.5 text-xs font-medium transition-colors duration-200 ${
            activeExperience === '3D' ? 'text-white' : 'text-gray-900'
          }`}
        >
          3D
        </span>

        {/* Toggle Circle */}
        <span
          className={`
            absolute inline-block size-6 rounded-full bg-white shadow-lg transition-transform duration-200 ease-in-out
            ${activeExperience === '3D' ? 'translate-x-6' : 'translate-x-0'}
          `}
        />

        {/* Right Label (3D) */}
        <span
          className={`pr-0.5 text-xs font-medium transition-colors duration-200 ${
            disabled ? 'text-gray-500' : activeExperience === '2D' ? 'text-gray-900' : 'text-white'
          }`}
        >
          2D
        </span>
      </button>
    </div>
  );
};
